import React, { useState, useCallback, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { format, parseISO, parse } from 'date-fns';
import { isEmpty, includes, isArray, assign } from 'lodash';
import { Button } from '@material-ui/core';
import axios from 'axios';

import { Report, UnidataTable, Modal } from '~/components';
import { RadioGroup, Autocomplete, DateTime, Input } from '~/components/Form';
import { Select } from '~/components/Form/v2';
import { recordFiltering } from '~/store/modules/descargaDetalhe/actions';
import { number, t } from '~/helpers';
import api from '~/services/api';

import RecordDetails from './RecordDetails';
import * as S from './styles';

export default function DlgRelDescargas() {
  const [loading, setLoading] = useState(false);
  const [hidden, setHidden] = useState(true);
  const [grid, setGrid] = useState(false);
  const [query, setQuery] = useState({});
  const [tank, setTank] = useState({});
  const [shift, setShift] = useState({ initial: [], final: [] });
  const [type, setType] = useState('geral');
  const [noctvt, setNoctvt] = useState('');
  const [rowQuery, setRowQuery] = useState({
    issuance_date: '',
    period: '',
    emitter: '',
    station: '',
    type: '',
  });

  const modalRef = useRef(null);
  const formRef = useRef(null);
  const dataRedux = useSelector((state) => state.descargaDetalhe);
  const { profile } = useSelector((state) => state.user);
  const { token } = useSelector((state) => state.auth);

  const titlePage = useMemo(() => 'Relatório de Recebimentos', []);

  const optionsTypeRadio = useMemo(
    () => [
      { label: 'Geral', value: 'geral' },
      { label: 'Lista Simples', value: 'listasimples' },
      { label: 'Comp. Volume', value: 'compvolume' },
      { label: 'Comp. Dens/Temp', value: 'compdenstemp' },
    ],
    []
  );

  const firstJobOptions = useMemo(
    () => [
      {
        post_desc: 'Todos',
        post_cod_posto: '',
      },
    ],
    []
  );

  const headerUnidataTable = useMemo(() => {
    const header = [
      { id: 'post_desc', label: 'Posto' },
      {
        id: 'desc_datahora',
        label: 'Data',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
      },
    ];

    if (['geral', 'listasimples'].includes(type)) {
      header.push(
        {
          id: 'desc_datahora',
          label: 'Hora',
          align: 'center',
          formatted: (value) => format(parseISO(value), 'HH:mm'),
        },
        { id: 'rvt', label: 'DNF NF/RVT' },
        { id: 'desc_veic_doc', label: 'DNF CT/VT' },
        { id: 'desc_num_pedido', label: 'DNF Pedido' },
        {
          id: 'desc_dt_emissao_nf',
          label: 'DNF Data Emissão NF',
          formatted: (value) => format(parseISO(value), 'dd/MM/yyyy'),
        },
        {
          id: 'desc_temp_car_doc',
          label: 'DNF Manifestado',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        {
          id: 'desc_vol_20_doc',
          label: 'DNF Vol. 20',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        {
          id: 'desc_temp_car_doc',
          label: 'DNF Temp',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        {
          id: 'desc_dens_20_doc',
          label: 'DNF Dens. 20',
          align: 'right',
          formatted: (value) => number(value, 4),
        },
        {
          id: 'desc_vol_amb_total',
          label: 'DR Vol. Amb',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'desc_vol_20_total',
          label: 'DR Vol. 20',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        {
          id: 'dif_amb',
          label: 'Dif. NF/REC Amb',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        {
          id: 'dif_20',
          label: 'Dif. NF/REC 20',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        { id: 'oper_cod_oper', label: 'Ope', align: 'right' }
      );
    }

    if (type === 'compvolume') {
      header.push(
        { id: 'turn_num_turn', label: 'Turno', align: 'center' },
        { id: 'desc_num_pedido', label: 'Pedido', align: 'center' },
        { id: 'desc_veic_doc', label: 'CT/TV Nº' },
        { id: 'tipo_ctvt', label: 'CT/TV Tipo' },
        {
          id: 'desc_temp_car_doc',
          label: 'VL NF',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'volume_medido',
          label: 'VL Medido',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'volume_dif',
          label: 'VL Dif',
          align: 'right',
          formatted: (value) => number(value, 1),
        },
        {
          id: 'desc_vol_20_doc',
          label: 'Vol. 20 NF',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'desc_vol_20_total',
          label: 'Vol. 20 Medido',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'vol20_dif',
          label: 'Vol. 20 Dif',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        { id: 'oper_cod_oper', label: 'Open', align: 'center' }
      );
    }

    if (type === 'compdenstemp') {
      header.push(
        { id: 'turn_num_turn', label: 'Turno', align: 'center' },
        { id: 'desc_veic_doc', label: 'CT/TV Nº' },
        { id: 'tipo_ctvt', label: 'CT/TV Tipo' },
        {
          id: 'desc_temp_car_doc',
          label: 'Temperatura NF',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'temp_medido',
          label: 'Temperatura Medido',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'temp_dif',
          label: 'Temperatura Dif',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'desc_dens_20_doc',
          label: 'Densidade NF',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'dens_20',
          label: 'Densidade Medido',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        {
          id: 'dens_dif',
          label: 'Densidade Dif',
          align: 'right',
          formatted: (value) => number(value, 2),
        },
        { id: 'oper_cod_oper', label: 'Open', align: 'center' }
      );
    }

    return header;
  }, [type]);

  const handleModifyReportData = useCallback(
    (data) => {
      const {
        tipo,
        datahorafinal,
        datahorainicial,
        post_cod_posto,
        post_desc,
        dataIni,
        dataFim,
      } = data;

      const ignoreList = [
        'datahorainicial',
        'datahorafinal',
        'tipo',
        'post_desc',
        'dataIni',
        'dataFim',
      ];
      const dataQuery = {
        wherefield: ['datahorafinal', 'datahorainicial'],
        valuewherefield: [dataFim || datahorafinal, dataIni || datahorainicial],
        typewherefield: ['MENOR_IGUAL', 'MAIOR_IGUAL'],
      };

      if (!post_cod_posto) ignoreList.push('post_cod_posto');

      Object.keys(JSON.parse(JSON.stringify(data)))
        .filter((form) => !includes(ignoreList, form))
        .forEach((form) => {
          dataQuery.wherefield.push(form);
          dataQuery.valuewherefield.push(data[form]);
          dataQuery.typewherefield.push('EQUALS');
        });

      setQuery(dataQuery);
      setHidden(false);
      setGrid(true);
      setRowQuery({
        issuance_date: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
        period: `${dataIni || datahorainicial} até ${dataFim || datahorafinal}`,
        emitter: profile.name,
        station: post_desc || 'Todos',
        type: optionsTypeRadio.find((v) => v.value === tipo).label,
      });

      return undefined;
    },
    [profile, optionsTypeRadio]
  );

  const openModalWithRecordDetails = useCallback((data, heading) => {
    if (!isEmpty(data))
      modalRef.current.handleOpenModal({ data, query: heading });
  }, []);

  const handleGetShift = useCallback(
    async (value, position) => {
      const dateTime = format(
        parse(value, 'dd/MM/yyyy HH:mm:ss', new Date()),
        'dd/MM/yyyy 00:00:00'
      );
      try {
        const URL = position === 'initial' ? 'getturnosinicio' : 'getturnosfim';
        const query =
          position === 'initial'
            ? { datahorainicio: dateTime }
            : { datahorafinal: dateTime };

        const { data } = await api.get(`/turno/${URL}`, {
          params: {
            ...query,
            codigoposto: tank.post_cod_posto,
            pesquisalista: true,
          },
        });

        setShift((state) => ({
          ...state,
          [position]: [
            {
              label: 'Nenhum',
              turn_datahora_ini: '',
              turn_datahora_fim: '',
            },
            ...data,
          ].map((item) => ({
            ...item,
            label:
              item.label ||
              `${item.turn_num_turn} - ${
                position === 'initial' ? item.hora_ini : item.hora_fim
              }`,
            value:
              position === 'initial'
                ? item.turn_datahora_ini
                : item.turn_datahora_fim,
          })),
        }));
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    },
    [tank]
  );

  const handleGetChangeTank = useCallback((data) => {
    setTank(data);
    setShift({ initial: [], final: [] });

    formRef.current.handleClear('dataIni');
    formRef.current.handleClear('dataFim');
  }, []);

  const handleExtractGrid = useCallback(
    async (data) => {
      try {
        setLoading(true);

        const REACT_APP_URL_DOWNLOAD = sessionStorage.getItem('URL_REPORT');
        const dateSplit = rowQuery.period.split(' até ');

        const dataFilter = assign(data, {
          relatorio: 'DESCARGAS',
          usuario: profile.username,
          strusuario: profile.name,
          datainicial: dateSplit[0],
          datafinal: dateSplit[1],
          codposto: tank.post_cod_posto || '',
          strposto: tank.post_desc || 'Todos',
          noctvt,
          tiporel: type,
          token,
        });

        const url = new URL(REACT_APP_URL_DOWNLOAD);
        url.search = new URLSearchParams(dataFilter);

        const response = await axios({
          url: url.href,
          method: 'POST',
          responseType: 'blob',
        });

        const file = new Blob([response.data], { type: response.data.type });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        } else {
          const objectUrl = URL.createObjectURL(file);
          window.open(objectUrl);
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    [token, profile, rowQuery, tank, noctvt, type]
  );

  // GRID
  if (grid && !isEmpty(query) && !isEmpty(rowQuery.period))
    return (
      <>
        <S.HeaderWrapper>
          <li>
            <span>Data Emissão:</span>
            {rowQuery.issuance_date}
          </li>
          <li>
            <span>Período:</span> {rowQuery.period}
          </li>
          <li>
            <span>Emissor:</span>
            {rowQuery.emitter}
          </li>
          <li>
            <span>Posto:</span>
            {rowQuery.station}
          </li>
          <li>
            <span>Tipo:</span>
            {rowQuery.type}
          </li>
        </S.HeaderWrapper>

        <UnidataTable
          fixed
          header={headerUnidataTable}
          read={recordFiltering}
          redux={dataRedux}
          title={titlePage}
          queryParams={query}
          onRow={(value) => openModalWithRecordDetails(value, rowQuery)}
          keys={['rownum']}
          detach="desc_num_doc"
          maxHeight="calc(100vh - 47rem)"
          create={false}
          update={false}
          delete={false}
        />

        <S.WrapperForm
          initialData={{ tipo: 'pdf' }}
          onSubmit={handleExtractGrid}
        >
          <RadioGroup
            row
            name="tipo"
            label="Formato de Saída"
            options={[
              { label: 'PDF', value: 'pdf' },
              { label: 'Excel', value: 'xls' },
            ]}
          />

          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={loading}
          >
            Imprimir
          </Button>
        </S.WrapperForm>

        <Modal
          disableBackdropClick
          disableEscapeKeyDown
          form
          ref={modalRef}
          title={`${titlePage} - Detalhe`}
          component={RecordDetails}
          labelConfirm="Imprimir"
          labelCancell="Fechar"
        />
      </>
    );

  return (
    <Report
      ref={formRef}
      open={hidden}
      title={titlePage}
      relatorio="DESCARGAS"
      onClose={() => setHidden(false)}
      serialize={handleModifyReportData}
      initials={{
        tipo: 'geral',
        datahorainicial: format(new Date(), 'dd/MM/yyyy 00:00:00'),
        datahorafinal: format(new Date(), 'dd/MM/yyyy 23:59:59'),

        idtarefapath: 'dlgDescargaDetalhada.swf',
      }}
    >
      <Autocomplete
        name="post_cod_posto"
        label="post_desc"
        url="usuarioposto"
        unique="post_cod_posto"
        title="Posto"
        first={firstJobOptions}
        hiddens={[{ name: 'post_desc' }]}
        getValue={(value) => {
          handleGetChangeTank(value);
        }}
      />

      <S.Columns grid={2}>
        <DateTime
          time
          name="datahorainicial"
          label="Data/Hora inicial"
          getValue={(value) => {
            handleGetShift(value, 'initial');
            formRef.current.handleClear('dataIni');
          }}
        />

        <Select name="dataIni" label="Turno" data={shift.initial} />
      </S.Columns>

      <S.Columns grid={2}>
        <DateTime
          time
          name="datahorafinal"
          label="Data/Hora final"
          getValue={(value) => {
            handleGetShift(value, 'final');
            formRef.current.handleClear('dataFim');
          }}
        />

        <Select name="dataFim" label="Turno" data={shift.final} />
      </S.Columns>

      <Input
        name="desc_veic_doc"
        label="Nº CT/VT"
        getValue={(value) => setNoctvt(value)}
      />

      <RadioGroup
        row
        name="tipo"
        label="Tipo"
        options={optionsTypeRadio}
        getValue={(value) => setType(value)}
      />
    </Report>
  );
}
